// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const BUYER_HAS_SEEN_AD = "\u010cetl z\u00e1jemce tvou zpr\u00e1vu?";
export const SELLER_HAS_SEEN_AD = "\u010cetl prodejce tvou zpr\u00e1vu?";
